/* eslint-disable no-multi-assign */
<template>
  <div
    id="anchor-container"
    class="anchor-container"
  >
    <div class="anchor-title">
      本页内容
    </div>
    <ul class="anchor-list">
      <li
        v-for="(item,index) in anchorList"
        :key="index"
        class="anchor-list-item"
        :class="activeIndex === item.id ? 'anchor-list-active' : ''"
      >
        <a
          @click="onChangeAnchor(item.id)"
        >{{ item.name }}</a>
      </li>
    </ul>
  </div>
</template>
<script>

export default {
  name: 'Anchor',
  props: {
    anchorList: {
      default() {
        return [];
      },
      type: Array
    },
    offsetTop: {
      type: Number,
      default: 56
    }
  },
  data() {
    return {
      activeIndex: -1,
      h2List: [],
    };
  },
  watch: {
    activeIndex() {
      this.$nextTick(() => {
        const anchorListDom = document.getElementsByClassName('anchor-list')[0];
        if (!anchorListDom) return;
        const anchorDom = anchorListDom.getElementsByClassName('anchor-list-active')[0];
        if (!anchorDom) return;
        const anchorPosition = anchorDom.getBoundingClientRect().top;
        // 检查锚点项是否被遮挡
        const anchorListDomTop = anchorListDom.getBoundingClientRect().top;
        const anchorListDomBottom = anchorListDom.getBoundingClientRect().bottom;

        if (anchorPosition < anchorListDomTop) {
        // 如果锚点项被遮挡，滚动到对应位置
          anchorListDom.scrollTop =  anchorListDom.scrollTop + anchorPosition - anchorListDomTop;
        } else if (anchorPosition > anchorListDomBottom) {
          anchorListDom.scrollTop = anchorListDom.scrollTop + anchorPosition - anchorListDomBottom + 32;
        }
      });
    }
  },
  mounted() {
    // window.addEventListener('scroll', this.setScroll);
    const index = window.location.hash.substr(1);
    this.setActiveAndScrollTo(index);
    this.setH2List();
    window.addEventListener('scroll', this.onScroll);
  },
  methods: {
    setActiveAndScrollTo(index) {
      setTimeout(() => {
        if (index) {
          document.documentElement.scrollTop = document.getElementById(index).offsetTop + 56;
          this.activeIndex = index;
        }
        if (!index && this.anchorList.length > 0) {
          this.activeIndex = this.anchorList[0].id;
        }
      }, 0);
    },
    onChangeAnchor(id) {
      if (this.activeIndex === id) {
        return;
      }
      this.$router.replace({ path: `${this.$route.path}#${id}` });
      this.setActiveAndScrollTo(id);
    },
    setH2List() {
      const dom = document.getElementsByClassName('article-container')[0].querySelectorAll('h2');
      for (let i = 0; i < dom.length ; i++) {
        if (dom[i].id) {
          this.h2List.push({
            id: dom[i].id,
            name: dom[i].innerText,
            range: [dom[i].offsetTop - this.offsetTop, dom[i].offsetTop + dom[i].offsetHeight + this.offsetTop]
          });
        }
      }
    },
    onScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      for (let i = 0; i < this.h2List.length; i++) {
        const { range } = this.h2List[i];
        if (scrollTop >= range[0] && scrollTop <= range[1]) {
          this.activeIndex = this.h2List[i].id;
          break;
        }
      }
    }
  },
};
</script>
<style lang="less">
  .anchor-container {
    // position: fixed;
    // right: 0;
    // top: 110px;
    // height: calc(100% - 110px);
    // margin-left: 6px;
    // overflow: hidden;
    .anchor-title {
      margin-bottom: 16px;
      line-height: 24px;
      font-size: 16px;
      font-weight: 600;
    }
    margin-top: 28px;
    width: 100%;
    .anchor-list {
      padding: 0;
      margin: 0;
      overflow: auto;
      max-height: 60vh;
      &::-webkit-scrollbar {
        display: none;
      }
      &-item {
        position: relative;
        padding: 5px 16px;
        list-style: none;
        border-left: 1px solid rgba(206, 213, 222, 0.30);
        // margin-left: 1px;
        a {
          cursor: pointer;
          display: block;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.90);
          line-height: 22px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      &-active {
        a {
          color:#0068FE;
        }
        &::before {
          content: '';
          position: absolute;
          left: -1px;
          top: 50%;
          transform: translateY(-50%);
          width: 1px;
          height: 16px;
          background-color: #0075FF;
          z-index: 1;
        }
      }
    }
  }
  .fixed-top {
    transition: 0.3s;
    top: 56px;
  }
  @media screen and (max-width: 1329px) {
    .anchor-container {
      // margin-top: -99999px;
    }
  }
</style>
